import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Tooltip } from "antd";
import { Row } from "antd";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import SearchIcon from "../../image/SearchIcon.svg";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";

const { Search } = Input;

const ArchiveRFQHistoryCompany = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ArchiveRFQHistoryCompany, setArchiveRFQHistoryCompany] = useState([]);
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const colors = ["#094E8F"];
  
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getArchiveRFQHistoryCompany = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(`float-rfq-restore/?company_id=${CompanyId}`, state);
        if (apiResponse.status) {
          setArchiveRFQHistoryCompany(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_rfq_history"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getArchiveRFQHistoryCompany();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "category_tree_name" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree_name";
    }
    if (sortField === "category_tree_name" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree_name";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "rfq_number" && sortOrder === "ascend") {
      sortingEnumKey = "rfq_number";
    }
    if (sortField === "rfq_number" && sortOrder === "descend") {
      sortingEnumKey = "-rfq_number";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }
    if (sortField === "rfqstatus" && sortOrder === "ascend") {
      sortingEnumKey = "rfqstatus";
    }
    if (sortField === "rfqstatus" && sortOrder === "descend") {
      sortingEnumKey = "-rfqstatus";
    }

    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }

    try {
      let apiResponse = await postRequest("float-rfq-restore/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("rfq_history_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
        navigate(`/request-for-quotation/history`);
      } else {
        ErrorNotificationMsg(t("error_in_restore_rfq_history"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    // {
    //   title: "SR no.",
    //   dataIndex: "SRno",
    //   key: "1",
    //   sorter: true,
    //   //width: 60,
    //   render: (text, record, index) => index + 1
    // },
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
      //width: 100,
    },
   
    {
      title: "RFQ Number",
      dataIndex: "rfq_number",
      key: "rfq_number",
      sorter: true,
      //width: 100,
    },
    {
      title: "Approval By",
      dataIndex: "rfq_approval_by_name",
      key: "rfq_approval_by_name",
      sorter: true,
      //width: 200,
      render: (rfq_approval_by_name) => (
        rfq_approval_by_name ? rfq_approval_by_name : "Pending"
      ),
    },
   
    {
      title: "RFQ Status",
      dataIndex: "rfq_status",
      key: "rfq_status",
      //width: 200,
      sorter: true,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      //width: 100,
      render: (text, record) => (
        <Space>
         <Tooltip
            color={colors}
            placement="right"
            title={
              <span style={{ color: "#fff" }}>
                Restore
              </span>
            }
          >
            <Popconfirm
              className="action"
              title={t("pop_restore_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleRestore(record.id)}
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("archive_RFQ_history")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history"> {t("pl_rfq_history")} </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_Archive")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("pl_company_address")}</h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Col> */}
          </Row>


          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={ArchiveRFQHistoryCompany}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() =>
                navigate(
                  `/request-for-quotation/history`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchiveRFQHistoryCompany;
